import { Component } from '@angular/core';
@Component({
    selector: 'app-fleet',
    templateUrl: './fleet.component.html',
    styleUrls: ['./fleet.component.css'],
    standalone: false
})
export class FleetComponent { }
